
<label class="switch">
  <input type="checkbox" [checked]="check"
         (change)="change($event.target.checked)">
  <span class="slider round"></span>
</label>

<!-- <label class="switch">
  <input type="checkbox" checked>
  <span class="slider round"></span>
</label>
 -->
